import {Component, Input, OnInit} from '@angular/core';
import {FormField} from 'hateoas-navigator';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-group',
  template: `<div *ngFor="let field of fields">
  <app-form-field [formGroup]="formGroup" [control]="formGroup.get(field.getName())" [field]="field"></app-form-field>
</div>
`,
  styles: [``]
})
export class FormGroupComponent implements OnInit {
  @Input()
  fields: FormField[];

  @Input()
  formGroup: FormGroup;

  ngOnInit(): void {
    if (!this.formGroup.controls) {
      throw new Error(`Erroneous type for sub-form: ${this.formGroup.constructor.name}`);
    }
  }
}
